module.exports = __webpack_public_path__ + "static/media/preview.e61fa1e2.png";